import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { Bonuses } from './components/Bonuses';
import { UrgencyCountdown } from './components/UrgencyCountdown';
import { Pricing } from './components/Pricing';
import { MasterComparison } from './components/MasterComparison';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalUrgency } from './components/FinalUrgency';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-green selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainSection data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <Bonuses data-id="element-7" />
        <UrgencyCountdown data-id="element-8" />
        <Pricing data-id="element-9" />
        <MasterComparison data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostOfInaction data-id="element-14" />
        <FinalUrgency data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}